

import Vue from 'vue'
import App from './App'
import router from './router'
import infiniteScroll from 'vue-infinite-scroll'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Loading from 'vux/src/components/loading/index.vue'

import './util/rem'
Vue.config.productionTip = false
Vue.use(infiniteScroll)
Vue.use(AjaxPlugin)
Vue.component('loading', Loading)
require('es6-promise').polyfill()

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js